/**
 * [CCI-18182] Diff-based segmenting — eligibility check.
 *
 * Whether the Post Stream Review ("Review moment") splits a top-level change into
 * finer diff-level sub-segments (`diffSegments`) instead of segmenting at the
 * top-level node boundary only.
 *
 * Driven by the `'diff-based-segmenting'` token of
 * `platform_editor_ai_review_moment_config`, AND-gated with the Review moment
 * experiment so the slice stays inside the Review moment cohort. [CCI-19338]
 */
import { isReviewMomentDiffBasedSegmentingEnabled } from '../../pm-plugins/ai-session-context/review-moment-config';
import { isReviewMomentEnabledNoExposure } from './review-moment-enabled';

/**
 * Returns true when diff-based segmenting is enabled for the current user.
 *
 * This is the **non-exposure-logging** variant: every call site lives on the
 * Review-moment render / read path, so the canonical Review moment exposure is
 * already logged by the Review moment gate-enforcement points.
 */
export function isDiffBasedSegmentingEnabled(): boolean {
	return isReviewMomentDiffBasedSegmentingEnabled() && isReviewMomentEnabledNoExposure();
}
